export interface RealWorldGalleryImage {
  src: string;
  caption?: string;
}

export interface RealWorldProject {
  id: string;
  title: string;
  summary: string;
  cardImage: string;
  /** Short labels for the card, e.g. Woodworking, Metal */
  tags?: string[];
  /** Lead paragraph on the detail page */
  detailIntro: string;
  detailParagraphs: string[];
  galleryImages: RealWorldGalleryImage[];
}

const realWorldProjects: RealWorldProject[] = [
  {
    id: 'chessboards',
    title: 'Chessboards',
    summary:
      'A 13″ square board built from fallen black walnut and cedar—milled from a log, strip-laminated into the chess pattern, and finished with polyurethane.',
    cardImage: '/images/chessboard.jpeg',
    tags: ['Woodworking', 'Chess'],
    detailIntro:
      'This board is 13 inches square, made from fallen black walnut and cedar. I started with a log: milled it into dimensional lumber, then ripped it into strips and glued them up. After sanding, I cross-cut the blank and flipped the segments horizontally so the light and dark strips alternate into a proper chessboard pattern. Final sanding and several coats of polyurethane protect the surface and bring out the grain.',
    detailParagraphs: [],
    galleryImages: [
      { src: '/images/chessboard.jpeg' },
      { src: '/images/chessboard2.jpeg' }
    ]
  }
];

const realWorldProjectById: Record<string, RealWorldProject> = Object.fromEntries(
  realWorldProjects.map((p) => [p.id, p])
);

function getRealWorldProject(id: string): RealWorldProject | undefined {
  return realWorldProjectById[id];
}

export { realWorldProjects, getRealWorldProject };
